export const COVID_RECORDS = () => {
    return {
        COVID_QUESTION: {//section
            COVID: {//QuestionsetCd
                YESNODATAELEMENT1: {//Dataelementcd
                    question: 'Did you travel or plan to travel to a COVID-19 affected country in the past 20 days or in the next 90 days?',
                    answer: ''
                }
            },
            ShareDetails: {
                FREETEXT1: {
                    question: 'If yes, please share details about travel locations and exact durations of stay(s)',
                    answer: ''
                }
            },
            TravelDetails: {
                FREETEXT1: {
                    question: 'Country',
                    answer: ''
                },
                FREETEXT2: {
                    question: 'City',
                    answer: ''
                },
                DATEELEMENT1: {
                    question: 'Date arrived',
                    answer: ''
                },
                FREETEXT4: {
                    question: 'Date Departed/Intednded duration',
                    answer: ''
                },
            },
            COVID19: {
                YESNODATAELEMENT1: {
                    question: 'Have you ever been incapable to work for more than 7 days or presently incapable to work?',
                    answer: ''
                }
            },
            Quarantine: {
                YESNODATAELEMENT1: {
                    question: 'Are/were you quarantined or have you been advised to self-isolate at home (by authorities/officials, a health care provider, medical staff or a medical advisor or by any other institution) or have you decided on your own to self-isolate yourself?',
                    answer: ''
                }
            },
            TestResult: {
                YESNODATAELEMENT1: {
                    question: 'Have you been diagnosed (based on a positive COVID-19 test result or based on your symptoms and your personal risk parameters) to have a proven or likely COVID-19 infection?',
                    answer: ''
                }
            },
            TestInfo: {
                YESNODATAELEMENT1: {
                    question: 'Did you ever have a COVID-19 test?',
                    answer: ''
                }
            },
            TestOutcome: {
                FREETEXT1: {
                    question: 'was it negative (i.e. COVID-19 virus was not detected) or was it positive (i.e. you were found to have a COVID-19 infection)? Please share details of all testing dates and results.',
                    answer: ''
                },
                DATEELEMENT1: {
                    question: 'Date',
                    answer: ''
                },
                FREETEXT2: {
                    question: 'Remarks',
                    answer: ''
                }
            },
            TestRecommended: {
                YESNODATAELEMENT1: {
                    question: 'is a COVID-19 test planned/recommended for you?',
                    answer: ''
                },
                FREETEXT1: {
                    question: 'Provide details',
                    answer: ''
                }
            },
            Symptoms: {
                FREETEXT1: {
                    question: 'Do you currently suffer or did you suffer during the last 14 days from any of the following symptoms:',
                    answer: ''
                },
                YESNODATAELEMENT1: {
                    question: 'Sore throat',
                    answer: ''
                },
                YESNODATAELEMENT2: {
                    question: 'Runny nose',
                    answer: ''
                },
                YESNODATAELEMENT3: {
                    question: 'Aches and pains',
                    answer: ''
                },
                YESNODATAELEMENT4: {
                    question: 'Tiredness',
                    answer: ''
                },
                YESNODATAELEMENT5: {
                    question: 'Fever',
                    answer: ''
                },
                YESNODATAELEMENT6: {
                    question: 'Cough',
                    answer: ''
                },
                YESNODATAELEMENT7: {
                    question: 'Shortness of breath or Difficulty breathing',
                    answer: ''
                },
                YESNODATAELEMENT13: {
                    question: 'Heaviness in chest or chest pain',
                    answer: ''
                },
                YESNODATAELEMENT10: {
                    question: 'Bluish discoloration of lips or face',
                    answer: ''
                },
                YESNODATAELEMENT11: {
                    question: 'Confused state of mind',
                    answer: ''
                },
                YESNODATAELEMENT12: {
                    question: 'Gastro-intestinal symptoms such as Nausea, vomiting and/or Diarrhoea',
                    answer: ''
                },
            },
            HOSPITALIZED: {
                YESNODATAELEMENT1: {
                    question: 'Have you been admitted to a hospital (or to any other kind of medical or public health institution/unit) while you have/had a COVID-19 infection or whilst you are/were suspected to have a possible COVID-19 infection?',
                    answer: ''
                },
                FREETEXT1: {
                    question: 'If yes, please share details of exact admission period and location(s)',
                    answer: ''
                }
            },
            OccupationDetails: {
                YESNODATAELEMENT1: {
                    question: 'Do you work in an occupation, where you have a higher risk to get in close contact with COVID-19 patients or with coronavirus contaminated material?',
                    answer: ''
                },
                FREETEXT1: {
                    question: 'If yes, please share details about your exact occupational duties.',
                    answer: ''
                }
            },
            HealthDetails: {
                YESNODATAELEMENT9: {
                    question: 'Are you currently in good health?',
                    answer: ''
                }
            }

        }
    }
}

export const AIR_RECORDS = () => {
    return {
        ANNEXURE_INSURANCE_REPOSITORY: {//section
            INSURANCEREPOSITORY1: {//QuestionsetCd 
                YESNODATAELEMENT9: {//Dataelementcd
                    question: 'Would you like to apply for epolicy?',
                    answer: ''
                }
            },
            INSURANCEREPOSITORY: {
                YESNODATAELEMENT1: {
                    question: 'Do you have an eIA account number? ',
                    answer: ''
                },
                NUMELEMENT1: {
                    question: 'Please provide eIA account number',
                    answer: ''
                }
            },
            REPOSITORYNAME: {
                REPOSITORYELEMENT1: {
                    question: 'Specify the Insurance Repository Name for eIA creation. List of Insurance Repository:',
                    answer: ''
                },
                LANGUAGEELEMENT1: {
                    question: 'Language',
                    answer: ''
                }
            }
        }
    }

}